


































































import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import Cookies from 'js-cookie'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'Login',
})
export default class extends Vue {
  private validateUsername = (rule: any, value: string, callback: Function) => {
    if (!value || !value.trim()) {
      callback(new Error('请输入用户名'))
    } else {
      callback()
    }
  }

  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (!value) {
      callback(new Error('请输入密码'))
    } else if (value.length < 6) {
      callback(new Error('密码必须在6位以上'))
    } else {
      callback()
    }
  }

  private loginForm = {
    username: Cookies.get('username') || '',
    password: '',
  }

  private loginRules = {
    username: [{ validator: this.validateUsername, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }],
  }

  private loading = false

  private handleLogin() {
    ;(this.$refs.loginForm as ElForm).validate(async (valid: boolean) => {
      if (!valid) return

      this.loading = true
      try {
        const res: any = await UserModule.Login(this.loginForm as any)
        if (res && String(res.code) === '1') {
          const redirect = (this.$route.query.redirect as string) || '/'
          this.$router.push(redirect)
        }
      } catch {
        this.$message.error('登录失败，请检查账号或密码')
      } finally {
        this.loading = false
      }
    })
  }
}
